import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import StatementsPage from "./pages/StatementsPage";
import PhotosPage from "./pages/PhotosPage";
import ContactPage from "./pages/ContactPage";
import ArchivePage from "./pages/ArchivePage";
import PressPage from "./pages/PressPage";
import AdminPage from "./pages/AdminPage";
import { Toaster } from "sonner";

/** Reset scroll to top whenever the route changes. */
const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);
  return null;
};

function App() {
  return (
    <div className="App">
      <div className="animated-bg" aria-hidden="true" />
      <div className="ambient-light" aria-hidden="true" />
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/statements" element={<StatementsPage />} />
          <Route path="/photos" element={<PhotosPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/archive" element={<ArchivePage />} />
          <Route path="/press" element={<PressPage />} />
          <Route path="/admin" element={<AdminPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={{
          style: {
            background: "rgba(6, 42, 61, 0.95)",
            border: "1px solid rgba(255,255,255,0.12)",
            color: "white",
          },
        }}
      />
    </div>
  );
}

export default App;
